const intrinsicDimensionsFromProps = _ref => {
  let {
    width,
    height
  } = _ref;

  if (width && height) {
    return {
      width,
      height
    };
  }

  return {};
};

export default intrinsicDimensionsFromProps;